module.exports = __webpack_public_path__ + "static/media/85450023-vZSzwSgs.bcf94a96.JPG";